import React from 'react';
import './PolicyFanaticismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {WinPointsStat} from "../../../PlayerStat/stats/WinPointsStat";
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  POLICY_FANATICISM_COINS_CONVERSION,
  POLICY_FANATICISM_RUINS_WIN_POINTS_INCOME_BONUS,
  POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D10,
  POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D12,
  POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D20,
  POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D6,
  POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D8,
  POLICY_FANATICISM_WIN_POINTS_CONVERSION
} from "../../../../configs/policy/fanaticism";

const PolicyFanaticismDescription = () => {
  const ruins = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/ruins.65862e11.png'}
    alt={'Руины'}
    title={'Руины'}
  />;
  const superRuins = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/super_ruins.97515170.png'}
    alt={'Великие руины'}
    title={'Великие руины'}
  />;

  const winPoints = <WinPointsStat
    text={`+${POLICY_FANATICISM_RUINS_WIN_POINTS_INCOME_BONUS}`}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const convertFrom = <WinPointsStat
    text={POLICY_FANATICISM_WIN_POINTS_CONVERSION}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left'}
  />;

  const convertTo = <CoinsStat
    text={POLICY_FANATICISM_COINS_CONVERSION}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left'}
  />;

  const arrow = <img
    className={'from-to-icon policy-description-icon'}
    src={'/img/icons/up.png'}
    alt={'Обменять'}
    title={'Обменять'}
  />;

  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;
  const meleeDamageValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damage}
    icon={melee}
  />

  return (
    <>
      <div className={'policy-description_line'}>
        Доход {ruins}{superRuins} {winPoints}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        Смежно {ruins}{superRuins} отряды имеют {meleeDamageValueAndIcon}:
      </div>

      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
          src={'/img/icons/unit d6 friend.png'}
          alt={'Отряд Пехота (макс. размер 6)'}
          title={'Отряд Пехота (макс. размер 6)'}
        />
        <span className={'text-war'}>
          +{POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D6}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d10 friend.png'}
          alt={'Отряд Тяжелая Пехота (макс. размер 10)'}
          title={'Отряд Тяжелая Пехота (макс. размер 10)'}
        />
        <span className={'text-war'}>
          +{POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D10}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d20 friend.png'}
          alt={'Отряд Элитная Пехота (макс. размер 20)'}
          title={'Отряд Элитная Пехота (макс. размер 20)'}
        />
        <span className={'text-war'}>
          +{POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D20}
        </span>
        ,
      </div>
      <div className={'policy-description_line'}>
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d8 friend.png'}
          alt={'Отряд Легкая Кавалерия (макс. размер 8)'}
          title={'Отряд Легкая Кавалерия (макс. размер 8)'}
        />
        <span className={'text-war'}>
          +{POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D8}
        </span>
        ,
        <img
          className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
          src={'/img/icons/unit d12 friend.png'}
          alt={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
          title={'Отряд Тяжёлая Кавалерия (макс. размер 12)'}
        />
        <span className={'text-war'}>
          +{POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D12}
        </span>
        .
      </div>

      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        Раз в раунд можно {convertFrom}{arrow}{convertTo}.
      </div>
    </>
  );
};

export default PolicyFanaticismDescription;
